/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://www.osim.com.tw",
  "jssAppName": "osim-web-shop-tw",
  "defaultLanguage": "zh-TW",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Wed Jun 04 2025 09:58:12 GMT+0700 (Indochina Time)",
  "gitVersion": "b7d95109b232384eec4b122bf0ce98c5c23b5d5d",
  "graphQLEndpoint": "https://www.osim.com.tw/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};